import React from 'react'
import { FeatureStyle } from './style'

import featureOne from "../../images/featureSection/featureOne.png";
import featureTwo from "../../images/featureSection/featureTwo.png";
import featureThree from "../../images/featureSection/featureThree.png";


const FeaturesSection = () => {
  return (
    <FeatureStyle>
        {/* Features-Section-Start */}
        <section className="row_am features_section" id="features">
      {/* container start */}
      <div className="container">
        <div className="features_inner">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
            data-aos-delay={300}
          >
            {/* h2 */}
            <h2>
              <span>Features</span> that makes app different!
            </h2>
            {/* p */}
            <p>
            Riva simplifies your athletic journey with easy registration, customizable profiles, and dynamic messaging tools. <br/> Discover and join various sports events, and enjoy exclusive premium benefits like enhanced interactions and <br/> event discounts. Join our vibrant community and elevate your athletic experience with Riva.
            </p>
          </div>
          {/* story */}
          <div className="features_block">
            <div className="row">
              <div className="col-md-4">
                <div
                  className="feature_box"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                >
                  <div className="image">
                    <img src={featureOne} alt="image" />
                  </div>
                  <div className="text">
                    <h4 className='text-color'>Home Screen</h4>
                    <p>
                    Discover and connect with athletes on Riva. Browse profiles to find matches based on your interests. Non-Premium users can view and like up to 3 profiles daily and chat if there's a mutual like. Premium users enjoy unlimited views and messaging.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="feature_box"
                  data-aos="fade-up"
                  data-aos-duration={1700}
                >
                  <div className="image">
                    <img src={featureTwo} alt="image" />
                  </div>
                  <div className="text">
                    <h4>Events</h4>
                    <p>
                    Explore Riva’s events section to find and participate in various sports events. Join events tailored to your interests to enhance your competitive experience. Premium users benefit from exclusive perks and discounts on event participation.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="feature_box"
                  data-aos="fade-up"
                  data-aos-duration={1900}
                >
                  <div className="image">
                    <img src={featureThree} alt="image" />
                  </div>
                  <div className="text">
                    <h4>Leaderboard</h4>
                    <p>
                    Check your performance on Riva’s leaderboard and see how you rank among other athletes. Non-Premium users can view event results, while Premium users can also view profiles and chat with athletes featured on the leaderboard.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* container end */}
    </section>
    {/* Features-Section-end */}
    
    </FeatureStyle>
  )
}

export default FeaturesSection
